import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

/**
 * Protects a route: requires authenticated user from AuthContext.
 * Usage: <Route path="/dashboard" element={<ProtectedRoute component={Dashboard} />} />
 */
export default function ProtectedRoute({ component: Component, children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '40vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ redirectAfterLogin: location.pathname + location.search }} replace />;
  }

  if (user.mustChangePassword && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />;
  }

  if (Component) return <Component />;
  return children;
}
